import handleLanguageChange from '@/utilites/handle-language-change';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useQueryClient } from '@tanstack/react-query';
import useBackendUser from '@/hooks/useBackendUser';
import { useEffect, useState } from 'react';
import { Select } from '@headlessui/react';
import languageConstants from '@/constants/language.constants';
import Image from 'next/image';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';

export default function UserMenuLanguageSwitcher() {
  const { translate } = useTypedTranslation<HeaderEnum>('header');

  const { t: tCommon } = useTranslation('common');
  const { data: user } = useBackendUser();
  const router = useRouter();
  const queryClient = useQueryClient();
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return router.locale === router.defaultLocale
      ? 'en'
      : (router.locale as string);
  });
  const [selectedLanguageImage, setSelectedLanguageImage] = useState('');
  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    await handleLanguageChange(
      e.target.value,
      tCommon,
      router,
      Boolean(user),
      queryClient
    );
  };

  useEffect(() => {
    setSelectedLanguage(
      router.locale === router.defaultLocale ? 'en' : (router.locale as string)
    );
  }, [router.locale, router.defaultLocale]);

  useEffect(() => {
    const languageData =
      languageConstants.localesWithIcons[
        selectedLanguage === 'en'
          ? 'en'
          : selectedLanguage === 'es'
            ? 'es'
            : selectedLanguage === 'fr'
              ? 'fr'
              : selectedLanguage === 'de'
                ? 'de'
                : 'it'
      ];
    setSelectedLanguageImage(languageData.icon);
  }, [selectedLanguage]);

  return (
    <div className="tw-relative tw-overflow-x-clip">
      <Select
        name="language"
        id="language"
        value={selectedLanguage}
        onChange={handleChange}
        className="tw-bg-transparent tw-text-transparent tw-border-0 tw-w-7 tw-h-7 tw-relative tw-z-50"
      >
        <option value="en" className="tw-text-gray-800">
          {translate(HeaderEnum['locales.english'])} (English)
        </option>
        <option value="de" className="tw-text-gray-800">
          {translate(HeaderEnum['locales.german'])} (Deutsch)
        </option>
        <option value="fr" className="tw-text-gray-800">
          {translate(HeaderEnum['locales.french'])} (Français)
        </option>
        <option value="it" className="tw-text-gray-800">
          {translate(HeaderEnum['locales.italian'])} (Italiano)
        </option>
        <option value="es" className="tw-text-gray-800">
          {translate(HeaderEnum['locales.spanish'])} (Español)
        </option>
      </Select>
      <div className="tw-absolute -tw-translate-y-1/2 -tw-translate-x-1/2 tw-top-1/2 tw-left-1/2">
        <Image
          src={selectedLanguageImage}
          alt={selectedLanguage}
          width={24}
          height={24}
        />
      </div>
    </div>
  );
}
